module.exports = __webpack_public_path__ + "img/apoio-green-web.cfcb0942.png";